import axios from '@/common/axios-utils';

export default {
  sendSMSCode(params: any): any {
    return axios.post('/api/crm/common/v1/opportunity/captcha/sendMessage', params);
  },
  save(params: any): any {
    return axios.post('/api/gw/crm/api/form/clue/save', params);
  },
};
